import React, {useState, useEffect} from "react";
import { InputText } from "commons/input-controls";
import {ReactComponent as SearchIcon } from "assets/icons/search.svg";
import {ReactComponent as CancelIcon } from "assets/icons/close.svg";
import { StandartButton } from "commons/form-controls";
import s from "./search-block.module.scss";

const SearchBlock = (props) => {

    const [searchStart, setSearchStart] = useState(false);
    const [searchText, setSearchText] = useState(props.searchText);

    useEffect(() => {
        //setSearchStart(false);
        setSearchText(props.searchText);
    }, [props]);

    const searchItem = () => {
        setSearchStart(true);
        props.searchItem(searchText)
    }

    const clearItem = () => {
        setSearchText(null);
        setSearchStart(false);
        props.searchItem(null);
    }

    const cancelButton = searchStart ? <StandartButton icon={CancelIcon} callback={clearItem.bind(this, false)} background={'var(--background)'}/> : null

    const setText = (text) => {
        setSearchText(text)
        
    }



    return (
        <div className={s.SearchBlock}>
            <InputText value={searchText} callback={setText}/>
            {cancelButton}
            <StandartButton disabled={!searchText || searchText == ''} title={props.getValue('SEARCH_BY_TITLE')} icon={SearchIcon} callback={searchItem.bind(this, true)} fill={'white'}/>
        </div>
    )
}

export default SearchBlock
